<template>
    <div :class="$style['meal-list']" v-loading="loading">
        <pt-page-search @search="search" @emptySearch="emptySearch" :isAddrouter="false"></pt-page-search>
          <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-label']" ref="table">
            <wt-table :list="tableData" :labels="tableLabels" >
                <el-table-column slot="before" label="" width="50">
                    <template  slot-scope="scope">
                        <el-radio v-model="selectIndex" :label="scope.row.index" :class="$style['meal-list-radio']" @change="selectMealRow(scope.row)"></el-radio>
                    </template>
                </el-table-column>
            </wt-table>
      </wt-paged-table>
      <div class="button-div">
          <el-button type="primary" @click="submit">选择</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </div>
</template>
<script>
import { mealListLabels } from '../goods-options'
import { getDayTypes } from 'enumeration/mall.js'
export default {
  name: 'meal-list',
  props: {
    pageSize: {
      type: Number,
      default: 6
    },
    genePackage: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableLabels: mealListLabels,
      page_size: this.pageSize,
      tableData: [],
      selectIndex: '',
      select_row: {},
      page: 0,
      loading: false,
      searchKey: null
    }
  },
  watch: {
    page (val) {
      this.selectIndex = ''
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.selectIndex = ''
      this.getTableData(this.page)
    },
    emptySearch () {
      this.searchKey = null
      this.getTableData(this.page)
    },
    getTableData (page, next) {
      this.page = page
      let data = {
        name: this.searchKey,
        page: page,
        size: this.page_size,
        sort: 'id,asc'
      }
      this.$store.dispatch('getDetectionPackageList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.tableData.forEach((item, index) => {
          this.genePackage.forEach(etem => {
            if (item.id === etem.packageId || item.id === etem.id) {
              this.selectIndex = index
              this.select_row = item
            }
          })
        })
        this.totalNumber = res.totalNumber
      }).catch(err => {
        this.$message.error(err || '获取套餐列表失败')
        this.$refs.table.showReTry()
      })
    },
    // 根据检测平台查周期
    technologyCycle () {
      let technologyType = (this.select_row.productBean && this.select_row.productBean.method && this.select_row.productBean.method.name) || this.select_row.sequencingTechnologyType
      //   let technologyType = this.select_row.sequencingTechnologyType
      this.loading = true
      this.$store.dispatch('technologyCycle', technologyType).then(res => {
        if (res) {
          this.select_row.cycle = res.cycle
          this.select_row.cycleType = res.dayType === 'WORK_DAY' ? 'WORKING_DAY' : res.dayType
          this.select_row.period = res.period
          this.$emit('selectMealList', this.select_row)
        } else {
          this.$message.error('您所选套餐没有相应周期')
          this.$emit('selectMealList', this.select_row)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '查询检测周期失败')
      })
    },
    selectMealRow (data) {
      this.select_row = data
    },
    submit () {
      if (Object.keys(this.select_row).length === 0) {
        this.$message.error('请选择检测平台或“取消”当前选择列表')
      } else {
        let productBean = this.select_row.productBean || {}
        this.select_row.cycle = productBean.testCycle && Number(productBean.testCycle.match(/P(\S*)D/)[1])
        this.select_row.cycleType = (productBean.dayType && productBean.dayType === 'WORK_DAY') ? 'WORKING_DAY' : productBean.dayType
        this.select_row.period = productBean.testCycle && productBean.dayType && (Number(productBean.testCycle.match(/P(\S*)D/)[1]) + getDayTypes(productBean.dayType))
        this.$emit('selectMealList', this.select_row)
        // this.technologyCycle()
      }
    //   this.$emit('selectMealList', this.select_row)
    },
    cancel () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style module lang="less">
@import "~less/var";
.meal-list{
}
.table-data-label{
    margin-top: 20px;
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
}
.meal-list-radio{
    :global
    .el-radio__label{
        display: none;
    }
    :global
    .el-radio__inner{
        border:1px solid @mainColor;
        border-radius:50%
    }
}
</style>
